import axios from "axios";
import { Confirm } from "notiflix";
import React, { useCallback, useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Modal from "react-modal";
import { useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { failed, success } from "../../../Utils/Alerts";
import { _isTrabzon, _plaka, _selectedMapSettings, _serverUrl2 } from "../../../config";
import { SuccessAlert, loadingSc } from "../../Layout/AlertDiv";
import { tempLayer, zoomToFeatureByXY } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";
import TaskImageLog from "../Tasks/TaskImageLog";
import TaskLog from "../Tasks/TaskLog";
import "./HouseSignUpdate.css";

const { imageType } = _selectedMapSettings;

export default function HouseSignUpdate() {
  const history = useHistory();
  const hSignID = useParams().id;

  const getUserInfo = useSelector((state) => state.getUserInfo);

  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [info, setInfo] = useState([]);
  const [kurumKontrolResim, setKurumKontrolResim] = useState([]);
  const [kontrolDurum, setKontrolDurum] = useState("");
  const [kontrolAciklama, setKontrolAciklama] = useState("");

  const onClickRemoveTask = async () => {
    let json = {
      kullanici: getUserInfo.Id,
      id: hSignID,
    };
    Confirm.show("Emin misiniz", "Görevi Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", () => {
      axios
        .post(_serverUrl2 + "/task/remove", json)
        .then((res) => {
          if (res.data.status) {
            success("İşlem Başarılı");
            history.push("/dashboard/task");
          } else {
            failed("Silme işlemi sırasında hata oluştu." + res.data.error);
          }
        })
        .catch((err) => {
          failed("Silme işlemi sırasında hata oluştu." + err);
        });
    });
  };

  const getInfosFromNode = useCallback(async () => {
    loadingSc(true);
    await axios
      .get(_serverUrl2 + "/hsign/get/" + hSignID)
      .then((res) => {
        const data = res.data.rows[0];
        if (res.data.status) {
          setInfo(data);
          setKontrolDurum(data.kontrol_durum);
          setKontrolAciklama(data.kontrol_aciklama);
          zoomToFeatureByXY(data.x, data.y);
        } else {
          failed("Veriler Getirilemedi");
        }
      })
      .catch(() => {
        failed("Veriler Getirilemedi");
      });

    await axios
      .get(`${_serverUrl2}/main/getImages/${imageType}/${hSignID}`)
      .then((res) => {
        if (res.data.status) {
          setImages(res.data.rows);
        } else {
          failed("Hata Oluştu!");
        }
      })
      .catch(() => {
        failed("Hata Oluştu!");
      });

    await axios
      .get(_serverUrl2 + "/main/getImages/5/" + hSignID)
      .then((res) => {
        if (res.data.status) {
          setKurumKontrolResim(res.data.rows);
        } else {
          failed("Hata Oluştu!");
        }
      })
      .catch(() => {
        failed("Hata Oluştu!");
      });

    loadingSc(false);
  }, [hSignID]);

  const gorevSonuclandir = async (bool) => {
    loadingSc(true);
    if (bool) {
      // ONAYLA
      await axios
        .post(_serverUrl2 + "/task/updateStatus", {
          gorev_kontrol_aciklama: document.getElementById("kontrolAciklama").value,
          gorev_durum: "ONAYLANDI",
          id: hSignID,
          username: getUserInfo.Id,
        })
        .then((res) => {
          if (res.data.status) {
            success("Görev Onaylandı.");
            setModalVisible(false);
            history.push("/dashboard/task");
          } else {
            failed("Hata Oluştu.");
          }
        })
        .catch(() => {
          failed("Hata Oluştu.");
        });
    } else {
      // REDDET
      await axios
        .post(_serverUrl2 + "/task/updateStatus", {
          gorev_kontrol_aciklama: document.getElementById("kontrolAciklama").value,
          gorev_durum: "REDDEDİLDİ",
          id: hSignID,
          username: getUserInfo.Id,
        })
        .then((res) => {
          if (res.data.status) {
            success("Görev Reddedildi.");
            setModalVisible(false);
            history.push("/dashboard/task");
          } else {
            failed("Hata Oluştu.");
          }
        })
        .catch(() => {
          failed("Hata Oluştu.");
        });
    }
    loadingSc(false);
  };

  const onClickDeleteImage = async (d, tip) => {
    Confirm.show("Emin misiniz", "Resimi Silmek İstediğinizden Emin Misiniz", "Evet", "Hayır", async () => {
      await axios.get(_serverUrl2 + "/main/deleteImage/" + tip + "/" + hSignID + "/" + d.id).then(() => {
        success("Resim Silindi!");
        getInfosFromNode();
      });
    });
  };

  const onClickKurumKontrolKayit = async () => {
    //
    // SADECE HATALI VE UYGUN SEÇİLMİŞSE DEVAM ETMELİ
    //
    if (kontrolDurum == "UYGUN" || kontrolDurum == "HATALI") {
      let json = {
        tip: 2,
        kontrol_durum: kontrolDurum,
        kontrol_aciklama: kontrolAciklama,
        kontrol_yapan_kullanici: getUserInfo.Id,
        kontrol_tarihi: new Date(),
        id: hSignID,
      };
      await axios.post(_serverUrl2 + "/organization/update", json).then((res) => {
        if (res.data.status) {
          alert("Kurum Kontrol Bilgisi Yapıldı!");
          return;
        }
        alert("İşlem başarısız.");
      });
      console.log(json);
    } else {
      return;
    }
  };

  const onChangeFile = async (e) => {
    let fromData = new FormData();
    let selectedFile = e.target.files[0];

    fromData.append("file", selectedFile);
    fromData.append("gorev_id", hSignID);
    fromData.append("plaka_kod", _plaka);
    fromData.append("kayit_tarihi", new Date().toISOString().split("T")[0]);
    fromData.append("ekleyen_kullanici", getUserInfo.Id);
    fromData.append("tip", 5);

    await axios
      .post(_serverUrl2 + "/main/addImage", fromData)
            .then(() => {
                SuccessAlert("Resim Eklendi");
                getInfosFromNode();
            })
            .catch(() => {});
    };

  useEffect(() => {
    MyMap.addLayer(tempLayer);
    getInfosFromNode();
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, [hSignID, getInfosFromNode]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn back-button" onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>Numarataja Ait Levha Bilgileri</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox text-start">
          <div className="row">
            <div className="col-sm-12">
              <hr className="m-2" />
            </div>
            <div className="col-sm-12">
              <table className="table table-sm table-bordered table-font-size">
                <tbody>
                  <tr>
                    <td colSpan={3}>
                      {" "}
                      <label style={labelStyle}>Numarataj Bilgileri</label>
                    </td>
                    <td>
                      {" "}
                      {hSignID != 0 && (
                        <div className="col-sm-4">
                          <TaskLog tip={2} id={hSignID} />
                          {info.gorev_durum == "ISLEMDE" && getUserInfo.Rol.includes("4") && (
                            <button className="redBtn" style={{ fontSize: "13px", width: "100px" }} onClick={() => onClickRemoveTask()}>
                              Görevi Sil
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>İlçe</th>
                    <td>{info.ilce_ad}</td>
                    <th>Mahalle</th>
                    <td>{info.mah_ad}</td>
                  </tr>
                  <tr>
                    <th>CSBM</th>
                    <td>{info.csbm_ad}</td>
                    <th>Kapı No</th>
                    <td>{info.kapi_no}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-sm-12" style={{ padding: "5px 20px" }}>
              <div
                className="textBox"
                style={{
                  textAlign: "left",
                  borderLeft: "10px solid rgba(82, 138, 174,1)",
                }}
              >
                <div
                  className="content"
                  style={{
                    textAlign: "left",
                    padding: "15px",
                    backgroundColor: "rgba(82, 138, 174,0.06)",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                        <tbody>
                          <tr>
                            <th
                              colSpan={4}
                              style={{
                                backgroundColor: "rgba(82, 138, 174,1)",
                                color: "white",
                                fontSize: "15px",
                              }}
                            >
                              <center>Saha Bilgileri</center>
                            </th>
                          </tr>
                          <tr>
                            <th>Son Güncelleyen Kullanıcı</th>
                            <td>
                              <Link to={"/dashboard/kullaniciDetay/" + info.son_guncelleyen_kullanici}>{info.son_guncelleyen_kullanici}</Link>
                            </td>
                          </tr>
                          <tr>
                            <th>Son Güncellenme Tarihi</th>
                            <td>{info.son_guncellenme_tarihi}</td>
                          </tr>
                          <tr>
                            <th>İşlem Durumu</th>
                            <td colSpan={3}>{info.islem_durum}</td>
                          </tr>
                          <tr>
                            <th>Saha Açıklaması</th>
                            <td colSpan={3}>{info.aciklama}</td>
                          </tr>
                          <tr>
                            <th>Sahadan Çekilen Resimler</th>
                            <td
                              style={{
                                flexDirection: "columnReverse",
                                flexWrap: "wrap",
                                display: "flex",
                                flexGrow: 2,
                              }}
                            >
                              {images.length == 0 ? (
                                ""
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    padding: "5px",
                                    width: "100%",
                                    gridTemplateColumns: "repeat(6, 1fr)",
                                  }}
                                >
                                  {images.map((d, i) => {
                                    return (
                                      <div
                                        key={i}
                                        className="d-flex"
                                        style={{
                                          width: "130px",
                                          flexDirection: "column",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          alt="Sahadan Çekilen Resim"
                                          src={d.foto_path}
                                          style={{
                                            borderRadius: "17px",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                          width={"130px"}
                                          onClick={() => {
                                            setSelectedImages(
                                              images.map((d) => {
                                                return d.foto_path;
                                              })
                                            );
                                            setSelectedImage(i);
                                          }}
                                        />
                                        <div className="d-flex justify-content-between">
                                          {getUserInfo.Rol.includes("3") && _isTrabzon && (
                                            <button
                                              className="redBtn"
                                              style={{
                                                fontSize: "11px",
                                                width: "40px",
                                                position: "absolute",
                                                bottom: "5px",
                                                left: "5px",
                                              }}
                                              onClick={() => onClickDeleteImage(d, 2)}
                                            >
                                              <i className="fas fa-trash"></i>
                                            </button>
                                          )}
                                          <TaskImageLog id={d.id} />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12" style={{ padding: "5px 20px" }}>
              <div
                className="textBox"
                style={{
                  textAlign: "left",
                  borderLeft: "10px solid rgba(255,165,0,1)",
                  backgroundColor: "rgba(255,165,0,0.05)",
                }}
              >
                <div
                  className="content"
                  style={{
                    textAlign: "left",
                    padding: "15px",
                    backgroundColor: "rgba(255,165,0,0.05)",
                  }}
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                        <tbody>
                          <tr>
                            <th
                              colSpan={4}
                              style={{
                                fontSize: "15px",
                                backgroundColor: "rgba(255,165,0,1)",
                              }}
                            >
                              <center>Kurum Bilgileri</center>
                            </th>
                          </tr>
                          <tr>
                            <th style={{ width: "175px" }}>Kontrolü Yapan Kullanıcı</th>
                            <td>{info.kontrol_yapan_kullanici}</td>
                            <th>Kontrol Tarihi</th>
                            <td>{info.kontrol_tarihi}</td>
                          </tr>
                          <tr>
                            <th>Kontrol Durumu</th>
                            <td>
                              <select
                                colSpan={3}
                                value={kontrolDurum ?? ""}
                                onChange={(event) => setKontrolDurum(event.target.value)}
                                style={{
                                  borderLeft: "3px solid orange",
                                  fontSize: "13px",
                                  backgroundColor: "#fffaf2",
                                }}
                                className="form-control form-select selectStyle"
                                disabled={!_isTrabzon}
                              >
                                <option value={""}></option>
                                <option>UYGUN</option>
                                <option>HATALI</option>
                                <option disabled>BEKLEMEDE</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <th>Kontrol Açıklaması</th>
                            <td colSpan={4}>
                              <input
                                className="form-control form-control-sm"
                                value={kontrolAciklama ?? ""}
                                onChange={(event) => setKontrolAciklama(event.target.value)}
                                style={{
                                  borderLeft: "3px solid orange",
                                  fontSize: "13px",
                                  backgroundColor: "#fffaf2",
                                }}
                                readOnly={!_isTrabzon}
                              ></input>
                            </td>
                          </tr>
                          <tr>
                            <th>Kontrol Resimleri</th>
                            <td colSpan={3}>
                              {_isTrabzon && <input type="file" accept="image/*" className="form-control form-control-sm" onChange={(e) => onChangeFile(e)} />}
                              {kurumKontrolResim != null && (
                                <>
                                  <div
                                    className="d-flex"
                                    style={{
                                      flexDirection: "row",
                                      padding: "5px",
                                      maxWidth: "100%",
                                      overflowX: "scroll",
                                    }}
                                  >
                                    {kurumKontrolResim.map((d, i) => {
                                      return (
                                        <div
                                          className="d-flex"
                                          style={{
                                            flexDirection: "column",
                                            position: "relative",
                                          }}
                                        >
                                          <img
                                            alt="Kontrol Resmi"
                                            src={d.foto_path}
                                            style={{
                                              borderRadius: "17px",
                                              width: "130px",
                                              height: "130px",
                                              padding: "5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setSelectedImages(
                                                kurumKontrolResim.map((d) => {
                                                  return d.foto_path;
                                                })
                                              );
                                              setSelectedImage(i);
                                            }}
                                          />
                                          <div className="d-flex justify-content-between">
                                            {getUserInfo.Rol.includes("3") && (
                                              <button
                                                className="redBtn"
                                                style={{
                                                  fontSize: "11px",
                                                  width: "40px",
                                                  position: "absolute",
                                                  bottom: "5px",
                                                  left: "5px",
                                                }}
                                                onClick={() => onClickDeleteImage(d, 5)}
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            )}
                                            <TaskImageLog id={d.id} />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </>
                              )}
                            </td>
                          </tr>
                          {_isTrabzon && (
                            <tr>
                              <td colSpan={2}></td>
                              {getUserInfo.Rol.includes("2") && (
                                <td colSpan={2}>
                                  <button className="btn btn-success btn-sm form-control" onClick={() => onClickKurumKontrolKayit()}>
                                    Kaydet
                                  </button>
                                </td>
                              )}
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImages.length !== 0 ? (
        <Lightbox
          mainSrc={selectedImages[selectedImage]}
          nextSrc={selectedImages[(selectedImage + 1) % selectedImages.length]}
          prevSrc={selectedImages[(selectedImage + selectedImages.length - 1) % selectedImages.length]}
          onCloseRequest={() => setSelectedImages([])}
          onMovePrevRequest={() => setSelectedImage((selectedImage + selectedImages.length - 1) % selectedImages.length)}
          onMoveNextRequest={() => setSelectedImage((selectedImage + selectedImages.length + 1) % selectedImages.length)}
        />
      ) : null}
      <Modal isOpen={modalVisible} contentLabel="Görevi Sonuçlandır" closeTimeoutMS={200} style={customStyles} shouldCloseOnOverlayClick={true}>
        <div className="row">
          <div className="col-sm-12" style={{ marginBottom: "10px" }}>
            <label>Kontrol Açıklaması</label>
            <textarea id="kontrolAciklama" className="form-control form-control-sm" />
          </div>
          <div className="col-sm-3">
            <button className="darkOrangeBtn" onClick={() => setModalVisible(false)}>
              Geri
            </button>
          </div>
          <div className="col-sm-1">&nbsp;</div>
          <div className="col-sm-4">
            <button className="redBtn" onClick={() => gorevSonuclandir(false)}>
              Görevi Reddet
            </button>
          </div>
          <div className="col-sm-4">
            <button className="greenBtn" onClick={() => gorevSonuclandir(true)}>
              Görevi Onayla
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const labelStyle = {
  fontWeight: "bold",
  fontSize: "13px",
};
const customStyles = {
  content: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "551px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  overlay: {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(0, 0, 0, 0.10)",
  },
};
